import { Fragment } from 'react';

import { Card, CardBody } from '@apigrowfinance/pbolt-card';

import { GetCardControlsConditionsResponse } from '@clients/domains/flexControls/flexControlAccountClient';
import ControlConditionsBlockItem from '@components/controlDetails/components/conditionsBlock/ControlConditionsBlockItem';

export type ControlConditionsBlockProps = {
    cardControlRules: GetCardControlsConditionsResponse[];
    isLoading: boolean;
    noColumnsPerRow: number;
};

const ControlConditionsBlock = ({
    cardControlRules = [],
    isLoading,
    noColumnsPerRow,
}: ControlConditionsBlockProps) => {
    return (
        <>
            {cardControlRules?.map((cardControlRuleItem, index) => (
                <Fragment key={cardControlRuleItem.id}>
                    <Card
                        isTopRadiusBorder={false}
                        isBottomRadiusBorder={
                            cardControlRules.length - 1 == index
                        }
                        isIndented>
                        <CardBody>
                            <ControlConditionsBlockItem
                                cardControlItem={cardControlRuleItem}
                                isLoading={isLoading}
                                noColumnsPerRow={noColumnsPerRow}
                            />
                        </CardBody>
                    </Card>
                </Fragment>
            ))}
        </>
    );
};

export default ControlConditionsBlock;
